import(/* webpackMode: "eager" */ "/root/elawphant/src/app/[locale]/prodat-ooo/page.tsx");
